import { State } from '../state';

export const OrganizationSelectors = {
    organization: (state: State) => state.Organization,
};
